import { z } from 'zod';
/**
 * Der Antwortvertrag von `GET /api/v1/me/anmeldungen` — Auftrag `W-profilseite`
 * (2026-08-31).
 *
 * **Drei Ergebnisse, nicht zwei.** `erfolgreich` und `fehlgeschlagen` allein
 * verstecken den Fall, den ein Anwender am ehesten sehen will: dass sein
 * eigenes Konto gerade GESPERRT ist. `gesperrt` steht nur, wenn
 * `auth.login_failed` mit dem Grund `locked` protokolliert wurde — ein
 * Versuch gegen ein Konto, das zu diesem Zeitpunkt schon gesperrt war. Ein
 * Versuch, der die Sperre selbst erst AUSLÖST, trägt weiterhin den Grund
 * `bad_password` (siehe `auth.service.ts`, `login()`) und erscheint deshalb
 * als `fehlgeschlagen` — dieselbe Ehrlichkeit wie beim Abzeichenstand der
 * Menüspalte: eine Unterscheidung, die die Ablage nicht trägt, wird nicht
 * erfunden.
 */
/** Wie ein Anmeldevorgang ausging. */
export const anmeldungsErgebnisSchema = z.enum(['erfolgreich', 'fehlgeschlagen', 'gesperrt']);
/**
 * Ein einzelner Anmeldevorgang, wie ihn `GET /api/v1/me/anmeldungen` ausliefert.
 *
 * **`ipAddress` ist `null`, nicht fehlend.** `audit_log.ip_address` ist eine
 * `inet`-Spalte ohne `NOT NULL`; ein fehlender Wert ist ein möglicher
 * Ablagezustand und keine Auslassung dieses Vertrags.
 */
export const anmeldungSchema = z
    .object({
    /** `bigint` der `audit_log`-Zeile, als Zeichenkette — dieselbe Form wie `AuditEntry.id`. */
    id: z.string(),
    occurredAt: z.string(),
    ergebnis: anmeldungsErgebnisSchema,
    ipAddress: z.string().nullable(),
})
    .strict();
/** Die Antworthülle — jüngste zuerst, dieselbe Reihenfolge wie `GET /api/v1/audit`. */
export const meAnmeldungenAntwortSchema = z
    .object({
    anmeldungen: z.array(anmeldungSchema),
})
    .strict();
//# sourceMappingURL=me.js.map